import ChevronLeft from "@spectrum-icons/workflow/ChevronLeft";
import ChevronRight from "@spectrum-icons/workflow/ChevronRight";
import clsx from "clsx";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "./CustomDatePicker.css";
import {
  DEFAULT_WINDOW_SIZE,
  getAllowedDates,
  getDefaultWindowOffset,
  getNavigableDates,
} from "./datePickerUtils";
import WeekView from "./WeekView";

const CustomDatePicker = ({ onDateSelect, selectedDate, width = "100%" }) => {
  const navigableDates = getNavigableDates();
  const [windowOffset, setWindowOffset] = useState(() => getDefaultWindowOffset(navigableDates));

  const visibleDates = navigableDates.slice(windowOffset, windowOffset + DEFAULT_WINDOW_SIZE);
  const canGoBack = windowOffset > 0;
  const canGoForward = windowOffset + DEFAULT_WINDOW_SIZE < navigableDates.length;

  useEffect(() => {
    if (!selectedDate && onDateSelect) {
      const allowedDates = getAllowedDates();
      const today = dayjs().startOf("day");
      const todayAllowed = allowedDates.find((date) => date.isSame(today, "day"));
      onDateSelect(todayAllowed || allowedDates[0]);
    }
  }, [selectedDate, onDateSelect]);

  const handleBack = (e) => {
    e.preventDefault();
    if (canGoBack) {
      setWindowOffset((offset) => offset - 1);
    }
  };

  const handleForward = (e) => {
    e.preventDefault();
    if (canGoForward) {
      setWindowOffset((offset) => offset + 1);
    }
  };

  return (
    <div className="cb-datepicker-container" style={{ width }}>
      <div className="cb-button-wrapper">
        <button
          onClick={handleBack}
          className={clsx("cb-arrow-btn left", {
            ["cb-disabled-dates"]: !canGoBack,
          })}
          disabled={!canGoBack}
          type="button"
          aria-label="Previous dates"
        >
          <ChevronLeft />
        </button>
      </div>
      <WeekView
        visibleDates={visibleDates}
        onDateSelect={onDateSelect}
        selectedDate={selectedDate}
      />
      <div className="cb-button-wrapper">
        <button
          onClick={handleForward}
          className={clsx("cb-arrow-btn right", {
            ["cb-disabled-dates"]: !canGoForward,
          })}
          disabled={!canGoForward}
          type="button"
          aria-label="Next dates"
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
};

export default CustomDatePicker;
